import React, { useEffect, useState, useContext } from "react";
import "./VoyahTaishanHero.css";

import LanguageSelector from "../../../LanguageSelector";
import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";

const parseHeroStats = (hero) => {
  if (!hero) return { mainStats: [], singleStats: [] };

  const statEntries = Object.keys(hero)
    .filter((k) => /^stat_\d+$/.test(k))
    .sort((a, b) => Number(a.split("_")[1]) - Number(b.split("_")[1]))
    .map((key) => ({
      key,
      num: Number(key.split("_")[1]),
      text: String(hero[key] || "").trim(),
    }))
    .filter((item) => item.text);

  const mainStats = [];
  const singleStats = [];

  statEntries.forEach(({ key, num, text }) => {
    if (num >= 7) {
      singleStats.push({ key, label: text, value: "" });
      return;
    }

    const sepIndex = text.indexOf(":");
    if (sepIndex !== -1) {
      mainStats.push({
        key,
        label: `${text.slice(0, sepIndex).trim()}:`,
        value: text.slice(sepIndex + 1).trim(),
      });
    } else {
      singleStats.push({ key, label: text, value: "" });
    }
  });

  return { mainStats, singleStats };
};

const VoyahTaishanHero = () => {
  const { currentLang } = useContext(LanguageContext);

  const [stats, setStats] = useState({ mainStats: [], singleStats: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadContent = async () => {
      try {
        setLoading(true);
        const response = await getPageContent("voyahtaishan", currentLang);
        setStats(parseHeroStats(response.sections?.hero));
      } catch (err) {
        console.error("Failed to load Voyah Taishan hero", err);
      } finally {
        setLoading(false);
      }
    };

    loadContent();
  }, [currentLang]);

  if (loading) return null;

  const { mainStats, singleStats } = stats;

  return (
    <section className="voyahtaishanhero">
      <div className="absolute top-6 right-6 z-50">
        <LanguageSelector />
      </div>

      <div className="voyahtaishanhero-stats">
        {mainStats.length > 0 && (
          <div className="voyahtaishanhero-stats-main">
            {mainStats.map((item) => (
              <div key={item.key} className="voyahtaishan-stat">
                <span className="voyahtaishan-stat-label">{item.label}</span>
                <span className="voyahtaishan-stat-value">{item.value}</span>
              </div>
            ))}
          </div>
        )}

        {singleStats.length > 0 && (
          <div className="voyahtaishanhero-stats-single-row">
            {singleStats.map((item) => (
              <div
                key={item.key}
                className="voyahtaishan-stat voyahtaishan-stat-single-item"
              >
                <span className="voyahtaishan-stat-single">{item.label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default VoyahTaishanHero;
